import React, {useContext} from 'react';
import {FeaturesList} from '../../../global.styles';
import {ResponseVehicle} from '../../../types/api';
import Length from './Length';
import {LayoutContext} from '../../../context/Layout';
import FeaturesTableLayout from '../../Layout/FeaturesTableLayout';
import {getVehicleName} from '../../../utils/getVehicleName';
import {useFeatureServices} from '../../../use-feature-services';
import {Language} from '../../../types/language';

export default ({vehicles}: {vehicles: ResponseVehicle[]}) => {
  const {columnCount: columns} = useContext(LayoutContext);
  const {'locale-service': localeService} = useFeatureServices();

  return vehicles.length ? (
    <FeaturesTableLayout
      propKey={'trim-dimension'}
      headers={vehicles.map((vehicle) =>
        getVehicleName(vehicle, localeService.language as Language)
      )}
    >
      <FeaturesList columns={columns}>
        {vehicles.map((vehicle) => (
          <td role="cell" key={'trim-highlights-' + vehicle.acode}>
            <Length
              vehicle={vehicle}
              key={'length-' + vehicle.acode}
            />
          </td>
        ))}
      </FeaturesList>
    </FeaturesTableLayout>
  ) : null;
};
